import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Tag } from 'antd';
import TransferSelectTree from '../TransferSelectTree';
import $$ from 'cmn-utils';
import { deepClone } from '@/utils/common';

/**
 *  formItem: {
      type: 'transfer',
      modal: true,
      dataSource: employees,
      normalize: (value) => value.map(item => item.key)
    }
 */
class TransferSelectTreeControlled extends Component {
  static propTypes = {
    targetNodes: PropTypes.array,
    sourceNodes: PropTypes.array,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    const { value, dataSource } = props;

    this.state = {
      targetNodes: value,
      sourceNodes: dataSource,
      visible: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if ('value' in nextProps) {
      const targetNodes = nextProps.value;
      this.setState(targetNodes);
    }
  }

  triggerChange = (targetKeys, targetNodes) => {
    this.setState({ targetNodes: targetNodes });

    const onChange = this.props.onChange;
    if (onChange) {
      onChange(targetNodes);
    }
  };

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  hideModal = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const { modal, ...otherProps } = this.props;
    const { sourceNodes, targetNodes } = this.state;
    const comp = (
      <TransferSelectTree
        {...otherProps}
        sourceNodes={sourceNodes}
        targetNodes={targetNodes}
        onChange={this.triggerChange}
      />
    );

    if (modal) {
      return (
        <div>
          <Button onClick={this.showModal}>请选择{otherProps.title}</Button>

          {targetNodes && targetNodes.length ? (
            <div className="transfer-tree-value-list">
              {targetNodes.map((item, index) => <Tag key={index}>{item.title}</Tag>)}
            </div>
          ) : null}

          <Modal
            className="antui-transfer-modal"
            title={'请选择' + otherProps.title}
            visible={this.state && this.state.visible}
            width={modal.width || 480}
            onOk={this.hideModal}
            onCancel={this.hideModal}
            okText="确定"
            cancelText="取消"
            {...modal}
          >
            {comp}
          </Modal>
        </div>
      );
    }

    return comp;
  }
}

/**
 * TransferTreeForm组件
 */
export default ({
  form,
  name,
  dict,
  formFieldOptions = {},
  record,
  initialValue,
  rules,
  onChange,
  dataSource,
  normalize,
  ...otherProps
}) => {
  const { getFieldDecorator } = form;

  let forEachChildList = (childList, sourceNodeMap) => {
    childList.map(item => {
      sourceNodeMap.set(item.key, item);

      //遍历子节点
      item.children && forEachChildList(item.children, sourceNodeMap);
    });
  }

  //节点对应Map
  let sourceNodeMap = new Map();

  dataSource.map(item => {
    sourceNodeMap.set(item.key, item);

    //遍历子节点
    item.children && forEachChildList(item.children, sourceNodeMap);
  });

  //这里的initialValue是初始化数据key的列表，需要组装成树的节点列表
  let initval = [];
  initialValue.map(item => {
    if (sourceNodeMap.get(item)) {
      //源数据 和 初始化 数据不能是同一个对象，必须要克隆一下，不然后面勾选节点会有问题
      initval.push(deepClone(sourceNodeMap.get(item)));
    }
  });

  if (initval.length === 0 && record && name) {
    let nameArray = name.split(".");
    let generateInitVal = record;
    nameArray.forEach(function(value,key,arr){　　//值，索引，数组（默认为选定数组）
      if(generateInitVal)
      generateInitVal = generateInitVal[value];
    })
    
    initval = generateInitVal;
  }
  
  // 如果存在初始值
  if (initval !== null && typeof initval !== 'undefined') {
    if ($$.isFunction(normalize)) {
      formFieldOptions.initialValue = normalize(initval);
    } else {
      formFieldOptions.initialValue = initval;
    }
  }

  // 如果有rules
  if (rules && rules.length) {
    formFieldOptions.rules = rules;
  }

  // 如果需要onChange
  if (typeof onChange === 'function') {
    formFieldOptions.onChange = value => onChange(form, value); // form, value
  }

  return getFieldDecorator(name, formFieldOptions)(
    <TransferSelectTreeControlled dataSource={dataSource} {...otherProps} />
  );
};



// WEBPACK FOOTER //
// ./src/components/Form/TransferSelectTreeForm.js